import { useEffect, useState } from "react";
import { getPresignedUrls } from "../utils/signedMedia";

/**
 * Resolves an array of stored S3 image/video URLs (private fmv-data bucket) to
 * short-lived presigned URLs so full-resolution media renders on preview pages.
 *
 * - Returns the original list while the request is in flight or on error, so
 *   something always renders.
 * - Order is preserved, so callers can keep using array indices.
 *
 * Implemented with plain state (no react-query dependency) so it works
 * regardless of provider setup.
 */
export function useSignedImages(urls) {
  const list = Array.isArray(urls) ? urls.filter(Boolean) : [];
  const key = list.join("|");
  const [signed, setSigned] = useState(list);

  useEffect(() => {
    let active = true;
    if (list.length === 0) {
      setSigned([]);
      return undefined;
    }
    getPresignedUrls(list).then((resolved) => {
      if (active) setSigned(resolved);
    });
    return () => {
      active = false;
    };
    // `key` captures the contents of `list`; re-run only when the URLs change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return signed;
}
